<template>
  <v-dialog v-model="dialog" scrollable width="750">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Tạo Lịch Bảo Dưỡng Định Kỳ</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <ScheduleForm ref="scheduleForm" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="save">LƯU LỊCH</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ScheduleForm from '@/modules/facility/maintenance/ScheduleForm.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ScheduleNewDialog',
  components: { ScheduleForm },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false
    }
  },
  watch: {
    state(val) {
      if (val) this.dialog = true
    }
  },
  methods: {
    ...mapActions('FacilityMaintenance', ['createSchedule']),
    cancel() {
      this.dialog = false
      if (this.$refs.scheduleForm) {
        this.$refs.scheduleForm.resetValidation()
      }
    },
    async save() {
      if (!this.$refs.scheduleForm.validate()) return

      this.$loading.active = true
      try {
        const payload = this.$refs.scheduleForm.getData()
        await this.createSchedule(payload)
        this.dialog = false
        this.$emit('updated')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
